module.exports = __webpack_public_path__ + "img/male_avatar-min.936a7b52.jpg";